import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { userSelector } from "../../store/selectors";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import emailjs from "@emailjs/browser";
import moment from "moment";
import "./LegalDocumentScreen.css";
import ProfileMainIcon from "../../assets/profile-main.svg";
import TextField from "@mui/material/TextField";

import ProfileBillingIcon from "../../assets/profile-billing.svg";
import ProfileNotificationsIcon from "../../assets/profile-notifications.svg";
import ProfileSecurityIcon from "../../assets/profile-security.svg";
import ProfileTeamIcon from "../../assets/users.svg";
import ProfileActiveSessionsIcon from "../../assets/profile-active-sessions.svg";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import toast from "react-hot-toast";
import {
  deleteAgreement,
  deleteAgreementVersion,
  fetchAgreement,
  fetchAgreements,
  fetchAgreementVersions,
  publishDocumentVersion,
  revokeUserAgreement,
} from "../../store/usersSlice";

import { IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import PrimaryButton from "../../components/PrimaryButton/PrimaryButton";
import InfoModal from "../../components/InfoModal/InfoModal";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import useIsMobile from "../../hooks/useIsMobile";
import AddAgreementModal from "../../components/AddAgreementModal/AddAgreementModal";
import { OrbitProgress } from "react-loading-indicators";
import AddDocumentVersionModal from "../../components/AddDocumentVersionModal/AddDocumentVersionModal";

const LegalDocumentScreen = () => {
  const user = useSelector(userSelector);
  const navigate = useNavigate();
  const { agreementId } = useParams();
  const [documentInfo, setDocumentInfo] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [addAgreementVersionModalVisible, setAddAgreementVersionModalVisible] =
    useState(false);
  const [versionToReuploadId, setVersionToReuploadId] = useState(null);
  const [versionsArray, setVersionsArray] = useState([]);

  useEffect(() => {
    updateVersionsList();
  }, []);

  const updateVersionsList = () => {
    dispatch(fetchAgreementVersions(agreementId)).then((res) => {
      if (!res.error) {
        setVersionsArray(res.payload);
      }
    });
    dispatch(fetchAgreement(agreementId)).then((res) => {
      if (!res.error) {
        setDocumentInfo(res.payload);
      }
    });
  };

  const inputFieldCx = {
    input: { color: "#F1F7FF" },
    display: "flex",
    width: isMobile ? "100%" : 403,
    fontSize: 15,
    borderRadius: 8,
    fontWeight: 500,
    backgroundColor: "#1f242e",
    // border: "1px solid #333b4b",
    borderRadius: "8px",
    "& .MuiInputBase-root.Mui-focused": {
      border: "1px solid #3496FF",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    "& .MuiInputBase-root": {
      border: "1px solid #333b4b",
      borderRadius: "8px",
      boxSizing: "border-box",
    },
    "& .MuiInputLabel-root": {
      color: "#717B8E",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#3496FF",
    },
  };

  const handleDeleteVersion = (version) => {
    if (confirm("Вы точно хотите удалить эту версию документа?")) {
      dispatch(
        deleteAgreementVersion({
          agreementId,
          documentVersionId: version.id,
        })
      ).then((res) => {
        if (!res.error) {
          updateVersionsList();
        }
      });
    }
  };

  const handleRevokeAgreement = (version) => {
    const userId = prompt("Введите id пользователя");
    if (!userId) return;
    if (confirm("Откатить согласие у данного пользователя?")) {
      dispatch(
        revokeUserAgreement({
          agreementId: +agreementId,
          versionId: version.id,
          userId: +userId,
        })
      ).then((res) => {
        if (!res.error) {
          toast.success("Успешно!");
        } else {
          toast.error("Ошибка");
        }
      });
    }
  };

  const handlePublishVersion = (version) => {
    if (
      confirm("Опубликовать эту версию? После этого её нельзя будет удалить")
    ) {
      dispatch(
        publishDocumentVersion({ agreementId, documentVersionId: version.id })
      ).then((res) => {
        if (!res.error) {
          updateVersionsList();
          toast.success("Версия опубликована!");
        } else {
          toast.error("Ошибка публикации");
        }
      });
    }
  };

  if (!user) return null;

  return (
    <div className={isMobile ? "App-mobile" : "App"}>
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "80%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div className="support-container" style={{ alignItems: "flex-start" }}>
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && (
          <ProfileSidebar activeTab="admin" subActive="agreements" />
        )) ||
          null}
        {/* MAIN CONTENT */}
        <main className={isMobile ? "support-main-mobile" : "support-main"}>
          {documentInfo ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 12,
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <h1 className="support-title">{documentInfo.name}</h1>
              <PrimaryButton
                style={{
                  fontSize: 14,
                  // padding: 0,
                  // margin: 0,
                  // width: 30,
                  // height: 30,
                }}
                text="+ Добавить версию"
                onClick={() => {
                  setAddAgreementVersionModalVisible(true);
                  setVersionToReuploadId(null);
                }}
              />
            </div>
          ) : (
            <OrbitProgress style={{ fontSize: 8 }} color="white" />
          )}

          {versionsArray.map((version) => (
            <div
              style={{
                width: "100%",
                height: 50,
                backgroundColor: "#1f242e",
                borderRadius: 15,
                padding: 15,
                paddingLeft: 25,
                paddingRight: 25,
                boxSizing: "border-box",
                color: "white",
                marginTop: 10,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <a
                href={version.pdfUrl}
                className="agreement-screen-item-title"
                style={{
                  fontSize: 16,
                  fontWeight: 600,
                  color: "#f1f7ff",
                  textDecoration: "none",
                }}
                onClick={() => {
                  if (!version.pdfUrl) {
                    setVersionToReuploadId(version.id);
                    setAddAgreementVersionModalVisible(true);
                  }
                }}
              >
                {`Версия ${version.versionNumber}${!version.pdfUrl ? " (повторите загрузку)" : version.status === "DRAFT" ? " (черновик)" : version.status === "ARCHIVED" ? " (архив)" : ""}`}
              </a>
              <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
                {version.status === "DRAFT" && (
                  <>
                    <span
                      onClick={() => handlePublishVersion(version)}
                      className="agreement-screen-item-title"
                      style={{
                        fontSize: 16,
                        fontWeight: 400,
                        color: "#f1f7ff",
                      }}
                    >
                      Опубликовать
                    </span>
                    <span
                      onClick={() => handleDeleteVersion(version)}
                      className="agreement-screen-item-title"
                      style={{
                        fontSize: 16,
                        fontWeight: 400,
                        color: "#f1f7ff",
                      }}
                    >
                      Удалить
                    </span>
                  </>
                )}
                {version.status !== "DRAFT" && (
                  <>
                    <span
                      // className="agreement-screen-item-title"
                      style={{
                        fontSize: 13,
                        fontWeight: 400,
                        color: "#f1f7ff",
                      }}
                    >
                      (от {moment(version.effectiveAt).format("DD.MM.YYYY")})
                    </span>
                    <span
                      onClick={() => handleRevokeAgreement(version)}
                      className="agreement-screen-item-title"
                      style={{
                        fontSize: 16,
                        fontWeight: 400,
                        color: "#f1f7ff",
                      }}
                    >
                      Откатить согласие
                    </span>
                  </>
                )}
              </div>
            </div>
          ))}
        </main>
        {addAgreementVersionModalVisible && (
          <AddDocumentVersionModal
            isOpen={addAgreementVersionModalVisible}
            agreementId={agreementId}
            versionToReuploadId={versionToReuploadId}
            onSuccess={() => {
              setAddAgreementVersionModalVisible(false);
              setVersionToReuploadId(null);
              updateVersionsList();
              toast.success("Новая версия документа выгружена!");
            }}
            onClose={() => setAddAgreementVersionModalVisible(false)}
          />
        )}
      </div>
    </div>
  );
};

export default LegalDocumentScreen;
